import styled from 'styled-components';

export const DashContainer = styled.div`
  .ant-statistic-content-value {
    font-size: ${({ theme }) => theme.fontSizes.extraLarge} !important;
    line-height: ${({ theme }) => theme.fontSizes.extraLarge} !important;
  }

  .ant-statistic-content-suffix {
    font-size: ${({ theme }) => theme.fontSizes.default} !important;
    line-height: ${({ theme }) => theme.fontSizes.default} !important;
  }
`;
